import React, {Component} from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import '../../../../../public/css/media/_mobileheader.scss';
import './mobileHeader.scss';
import { getFeaturedBannerList, getMainBannerList } from '../../../../actions/CmsActions';
import { getProhibitedParcel, getNotification, readNotification, readAllNotification  } from '../../../../actions/ParcelAction'
import { disabledCart } from '../../../../utils/utils';
import logo from '../../../../assets/images/brand-icon-mobile.svg';
import userIcon from '../../../../assets/images/icon-user.svg';
import notifIcon from '../../../../assets/images/notification.svg';
import notifActiveIcon from '../../../../assets/images/notification-active.svg';
import bars from '../../../../assets/images/bars.svg';
// import search from '../../../../assets/images/search.svg';
import MobileNotifMenu from './MobileNotifMenu'
import MobileProfileMenu from './MobileProfileMenu'
import MobileHeaderMenu from './MobileHeaderMenu'
import { handleAppUrl } from '../../../../utils/urls';

class MobileHeaderSidenav extends Component {
  state = {
    isSideNavOpen: false,
    isSideNavOpenNotif: false,
    isNavProfileOpen: false,
    isAuthenticated: false,
    login: null,
    notification: "",
  }

  componentWillMount() {
    this.props.getFeaturedBannerList();
    this.props.getMainBannerList();
    if (localStorage.jwtToken) {
      this.props.getProhibitedParcel(localStorage.jwtToken);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.isAuthenticated && nextProps.login.fetched && this.props.login.fetched && !nextProps.parcel.notification_error){
      if (nextProps.parcel.notification){
        const notification = nextProps.parcel.notification_fetched ? nextProps.parcel.notification.data.filter(notif => notif.attributes.read === 0) : null;
        this.setState({ notification })
      }
    }
    this.setState({
      isSideNavOpen: nextProps.isSideNavOpen,
      isAuthenticated: nextProps.isAuthenticated,
      login: nextProps.login,
    });
  }
  handleLogout() {
    localStorage.removeItem('jwtToken');
    this.setState({isAuthenticated: false}, () => this.props.logout());
  }

  handleScrollDisplay(shouldHide) {
    //disable scroll of body when mobile menu is open
    if (shouldHide) {
      document
        .getElementsByTagName('body')[0]
        .setAttribute('class', 'noscroll');
      return;
    }

    document.getElementsByTagName('body')[0].classList.remove('noscroll');
  }
  // handleTrackPackage() {
  //   localStorage.setItem("trackPackage", "true");
  // }


  render() {
    return (
      <div>
        <header className="mobile-header">
          <div className="primary-nav-mobile">
            <Link tabIndex="0" to="/" className="clearfix">
              <img alt='logo' src={logo} />
            </Link>
            {
              this.props.isAuthenticated || localStorage.jwtToken ?
                <div>
                  <img
                    alt="icon"
                    src={this.state.notification && this.state.notification.length ? notifActiveIcon : notifIcon}
                    style={{ paddingLeft: 20, marginRight: 10 }}
                    onClick={() => { 
                      this.setState({ isSideNavOpenNotif: true }) 
                      this.handleScrollDisplay(true)
                      }} />
                  <img
                    alt="icon"
                    src={userIcon}
                    style={{ paddingLeft: 20, marginRight: 10 }}
                    onClick={() => {
                      this.setState({ isNavProfileOpen: true })
                      this.handleScrollDisplay(true)
                      }} />
                </div> :
                <div className="mobile-login-signup-links ">
                  <Link
                    to='/signin'
                    style={{ color: '#AA0E0E', fontWeight: 600, padding: '0px 20px', borderRight: '1px solid #E2E2E2' }}>SIGN IN</Link>
                  <Link
                    to='signup'
                    style={{ color: '#AA0E0E', fontWeight: 600, border: '1px solid #AA0E0E', borderRadius: 25, marginLeft: 20, padding: '0px 20px' }}>SIGN UP</Link>
              </div>
            }
          </div>
          <div className='secondary-nav-mobile '>
            <ul className='secondary-nav-mobile-links'>
              <li><Link to='/how-it-works'>How it works</Link></li>
              
              <li style={{ marginLeft: 15 }}><a href={`${handleAppUrl()}/shipping-estimate`} target='_blank'>Shipping Estimate</a></li>
              <li style={{ marginLeft: 15 }}><a href={`${handleAppUrl()}/track`} target='_blank'>Tracking</a></li>
            </ul>
            <div>
              {/* <img alt='icon' src={search} /> */}
              <img alt='icon' src={bars}  style={{ marginLeft: 15 }} onClick={() => { 
                this.setState({ isSideNavOpen: true }) 
                this.handleScrollDisplay(true)
              }}/>
            </div>
          </div>
        </header>
        <MobileNotifMenu
          isShown={this.state.isSideNavOpenNotif}
          notification={this.state.notification}
          readAllNotification={this.props.readAllNotification}
          readNotification={this.props.readNotification}
          closeSideNav={() => {
            this.setState({isSideNavOpenNotif: false})
            this.handleScrollDisplay(false)
            }} />
        <MobileProfileMenu
          isShown={this.state.isNavProfileOpen}
          login={this.props.login}
          isAuthenticated={this.props.isAuthenticated}
          isMenuDisabled={disabledCart}
          logout={this.props.logout}
          closeMenu={() => {
            this.setState({isNavProfileOpen: false})
            this.handleScrollDisplay(false)
            }} />
        <MobileHeaderMenu
          isShown={this.state.isSideNavOpen}
          login={this.props.login}
          isAuthenticated={this.props.isAuthenticated}
          logout={this.props.logout}
          closeMenu={() => { 
            this.setState({isSideNavOpen: false}) 
            this.handleScrollDisplay(false)
            }} />
      </div>
    );
  }
};

const mapDispachToProps = { 
  getFeaturedBannerList, 
  getMainBannerList, 
  getProhibitedParcel, 
  getNotification, 
  readNotification, 
  readAllNotification }

const mapStateToProps = state => ({
  cms: state.cms,
  parcel: state.parcel
})

export default connect(mapStateToProps, mapDispachToProps)(MobileHeaderSidenav)



/** WEBPACK FOOTER **
 ** ./src/components/Layout/Header/MobileHeader/index.js
 **/